import { BaseModalComponent } from './../base/base-modal.component';
import { PHONE_REGEX, EMAIL_REGEX } from './../../../../../shared/regular-expressions/regex';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';
import { setValidators } from '../../../../../shared/validators/set-validators';

export function getTelecomFormGroup(): FormGroup {
  return new FormGroup({
    system: new FormControl(''),
    value: new FormControl(''),
    rank: new FormControl('')
  });
}

@Component({
  selector: 'inc-telecom-add',
  templateUrl: './telecom-add.component.html'
})

export class TelecomAddComponent extends BaseModalComponent implements OnInit {
  title = 'CONTACT_INFO';

  constructor(modalController: ModalController, private navParams: NavParams) {
    super(modalController);
    this.reset(getTelecomFormGroup());
    this.form.controls.system.setValue('EMAIL');
  }

  ngOnInit() {
    super.ngOnInit();
    const extraValidators = this.navParams.get('extraValidators');
    if (extraValidators) { this.form = setValidators(this.form, extraValidators); }
  }

  save() {
    this.baseSave({ value: { telecom: this.form } });
  }

  setValidator(event) {
    this.form.controls.value.setValidators([Validators.required, Validators.pattern(EMAIL_REGEX)]);
    if (event.detail.value === 'PHONE') {
      this.form.controls.value.setValidators([Validators.required, Validators.pattern(PHONE_REGEX)]);
    }
    this.form.controls.value.setValue('');
  }

}
